import {Formik} from 'formik'
import {addMemberSchema} from '../../utils/validation'
import Input from '../../components/core/input'
import text from './text.json'
import {SimpleBlueButton} from '../../components/core/button'
import {useState} from 'react'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import {useDispatch} from 'react-redux'
import {addTeamMember} from '../../stores/members'
import LimitManager from '../../utils/limitManager'
import {useParams} from 'react-router-dom'
import {trimStringValues} from '../../utils/text'
import RenderedForPaid from '../../components/pages/RenderedForPaid'
import usageLimits from '../../data/usageLimits.json'

const MemberForm = ({closeModal, fetchInvitationsMembers, memberCount}) => {
    const {teamId} = useParams()
    const formIsDisabled = memberCount >= LimitManager.getTeamMemberLimit()
    const [buttonIsDisabled, setButtonIsDisabled] = useState(false)
    const [activeInfo, setActiveInfo] = useState(null)
    const dispatch = useDispatch()
    const isExceeded = Number(LimitManager.getTeamMemberLimit()) === memberCount
    const names = {
        channel_type: 'channel_type',
        channel_value: 'channel_value'
    }

    const channelTypeOptions = [
        {
            value: 'email',
            label: 'Email'
        }
    ]

    const initialFormValues = {
        [names.channel_type]: channelTypeOptions[0],
        [names.channel_value]: ''
    }

    const addMember = async(values, {setFieldError}) => {
        const formData = {
            ...values,
            [names.channel_type]: values[names.channel_type]?.value
        }
        const trimmedFormData = trimStringValues(formData)
        setButtonIsDisabled(true)
        const res = await dispatch(addTeamMember(teamId, trimmedFormData, setFieldError))
        if (res) {
            fetchInvitationsMembers()
            closeModal()
        }
        setButtonIsDisabled(false)
    }

    const handleInfo = (index, state) => {
        state ? setActiveInfo(index) : setActiveInfo(null)
    }

    const getPaidText = () => {
        return LimitManager.getLimitDiff(usageLimits.limit_keys.team_member_count.limit_key, memberCount) > 0 && text.for_paid.replace(':members_limit', LimitManager.getTeamMemberLimit()).replace(':members_count', LimitManager.getLimitDiff(usageLimits.limit_keys.team_member_count.limit_key, memberCount))
    }

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialFormValues}
            onSubmit={addMember}
            validationSchema={addMemberSchema}
            validateOnBlur={false}
            validateOnChange={false}
        >
            {({values, errors, handleChange, handleSubmit, setFieldValue}) => (
                <form onSubmit={handleSubmit} className="modal-body">
                    <RenderedForPaid
                        forPaidText={getPaidText() || text.for_paid_general}
                        isExceeded={isExceeded}
                        isTextWithLimits={!!getPaidText()}/>
                    <Input
                        type="text"
                        value={values[names.channel_value]}
                        onChange={handleChange}
                        placeholder={text.channel_value}
                        name={names.channel_value}
                        error={errors[names.channel_value]}
                        inputIsDisabled={formIsDisabled}
                        infoText={text.channel_value_info}
                        activeInfo={activeInfo === names.channel_value}
                        handleInfo={(state) => handleInfo(names.channel_value, state)}/>
                    <SimpleBlueButton type="submit" disabled={formIsDisabled || buttonIsDisabled}>
                        {buttonIsDisabled && <ButtonLoader/>}
                        {text.submit}
                    </SimpleBlueButton>
                </form>
            )}
        </Formik>
    )
}

export default MemberForm
